import React from 'react';
import { Stack } from '@mui/material';
import { Navigate } from 'react-router-dom';
import orderingData from '../../constants/products/ordering';
import ProductHero from './components/ProductHero';
import ProductSection from './components/ProductSection';
import RecommendationSection from './components/RecommendationSection';
import { STACK_PRODUCT_SECTION_COMPONENT } from '../../constants/mui-components';
import useGetCountry from '../../helpers/useGetCountry';
import CountryEnum from '../../constants/country-enum';

function Ordering() {
  const country = useGetCountry();
  if (country === CountryEnum.MEXICO) {
    return <Navigate to="/" replace />;
  }
  return (
    <>
      <ProductHero productData={orderingData} />
      <Stack className={STACK_PRODUCT_SECTION_COMPONENT}>
        <ProductSection productData={orderingData.description_information} />
        <ProductSection
          productData={orderingData.benefits_information}
          flexDirection="row-reverse"
        />
        <ProductSection
          productData={orderingData.requirements_information}
          stackProps={{
            style: {
              gap: '2rem',
            },
          }}
        />
        <RecommendationSection actualProductName={orderingData.name} />
      </Stack>
    </>
  );
}

export default Ordering;
